function anyAssignedElements(slot) {
    return slot.assignedElements({ flatten: true }).length > 0;
}
function anyNonEmptyTextAssigned(slot) {
    const temp = slot
        .assignedNodes({ flatten: true }) // all assigned nodes
        .filter(node => node.nodeType === 3) // all text nodes
        .filter(node => { var _a; return (_a = node.nodeValue) === null || _a === void 0 ? void 0 : _a.trim(); }); // Not sure about this one, but it is meant to remove tabs and new lines of html formatting.
    return temp
        .length > 0;
}
export function checkSlot(slot) {
    slot.classList.toggle('skapa-empty', !(anyAssignedElements(slot) || anyNonEmptyTextAssigned(slot)) // if there are assigned elements or non empty text then its NOT empty.
    );
}
export function slotChange(event) {
    const slot = event.target;
    checkSlot(slot);
}
